import { Module, RegisterOptions } from "vuex-class-modules";
import ListStoreVuex from "../../../../common/src/stores/general/ListStoreVuex";
import { Api } from "../../../../common/src/api/Api";
import { ReportFilterStore } from "./ReportFilterStore";
import { ReportListItem, ReportListResponse } from "@gsx/common/src/types/http/dashboard/report";

@Module({ generateMutationSetters: true })
export class ReportListStore extends ListStoreVuex<ReportListItem> {
    query: string = "";
    pageSize: number = 20;

    constructor(
        private readonly api: Api,
        private readonly reportFilterStore: ReportFilterStore,
        options: RegisterOptions,
    ) {
        super(options);
    }

    protected async fetch(): Promise<ReportListResponse> {
        return this.api.dashboard.reports.list({
            ...this.queryParams,
            query: this.query,
            logicalOperator: this.reportFilterStore.logicalOperator,
            applicationTags: Array.from(this.reportFilterStore.applicationTags),
            operatingRegimeTags: Array.from(this.reportFilterStore.operatingRegimeTags),
            productTags: Array.from(this.reportFilterStore.productTags),
            serviceTags: Array.from(this.reportFilterStore.serviceTags),
            customTags: Array.from(this.reportFilterStore.customTags).map((customTag) =>
                customTag.slice(customTag.indexOf(":") + 1),
            ),
            afterYear: `${this.reportFilterStore.afterYear}`,
            beforeYear: `${this.reportFilterStore.beforeYear}`,
        });
    }
}
